var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.834 4C14.6514 4 11.5991 5.26428 9.3487 7.51472C7.09827 9.76515 5.83398 12.8174 5.83398 16H1.83398L7.02065 21.1867L7.11398 21.3733L12.5007 16H8.50065C8.50065 10.84 12.674 6.66667 17.834 6.66667C22.994 6.66667 27.1673 10.84 27.1673 16C27.1673 21.16 22.994 25.3333 17.834 25.3333C15.2607 25.3333 12.9273 24.28 11.2473 22.5867L9.35398 24.48C10.4652 25.5973 11.7866 26.4837 13.2421 27.0878C14.6975 27.6919 16.2581 28.002 17.834 28C21.0166 28 24.0688 26.7357 26.3193 24.4853C28.5697 22.2348 29.834 19.1826 29.834 16C29.834 12.8174 28.5697 9.76515 26.3193 7.51472C24.0688 5.26428 21.0166 4 17.834 4ZM16.5007 10.6667V17.3333L22.2073 20.72L23.1673 19.1067L18.5007 16.3333V10.6667H16.5007Z",
    fill: "#8493AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.e2a6899797b089d4b07a39abe50d8182.svg";
export { ForwardRef as ReactComponent };